<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >

      <v-data-table
        :headers="headers"
        :items="contactos"
        item-key="name"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-row
            class="pa-4"
          >
            <v-col>
              <v-btn
                color="primary"
                :loading="isLoadingDownload"
              @click="exportarExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
            </v-btn>
            </v-col>
            <v-col
                class="py-0 my-0"
            >
                <v-text-field
                  v-model="search"
                  label="Buscar contactos..."
                  outlined
                />
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarContacto(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 ml-2"
                v-bind="attrs"
                @click="$router.push({ name: 'contactos de entidades tecnicas', params: { entidadId: item.id } })"
                v-on="on"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>Contactos</span>
          </v-tooltip> -->
        </template>
      </v-data-table>
    </v-container>

    <v-btn
      class="mx-2"
      right
      absolute
      fab
      dark
      color="indigo"
      @click="newContacto"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>
    <new-contactos-cliente
      ref="newContactoCliente"
      @onCreate="onCreate"
    />
    <dialog-personalizado
      ref="dialogContacto"
      @onDialog="onDialog"
    />
  </div>
</template>

<script>
  // import firebase from 'firebase'
  import NewContactosCliente from './components/NewContactoInstalador.vue'
  import DialogPersonalizado from '../components/Dialog.vue'
  import xlsx from 'json-as-xlsx'

  // const db = firebase.firestore()

  export default {
    components: {
      NewContactosCliente,
      DialogPersonalizado,
    },
    data () {
      return {
        isLoadingDownload: false,
        headers: [
          { text: 'Nombre', value: 'nombre' },
          { text: 'Apellido paterno', value: 'primer_apellido' },
          { text: 'Apellido materno', value: 'segundo_apellido' },
          { text: 'Dni', value: 'dni' },
          { text: 'Celular', value: 'celular' },
          { text: 'Correo', value: 'correo' },
          { text: 'Departamento', value: 'departamento' },
          { text: 'Provincia', value: 'provincia' },
          { text: 'Distrito', value: 'distrito' },
          { text: 'Direccion', value: 'direccion' },
          { text: 'Especializacion', value: 'especializacion' },
          { text: 'Accions', value: 'accions' },
        ],
        contactos: [],
        search: '',
        cliente_id: undefined
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil === 'Administrador'
    },
    },
    mounted () {
      // this.existeClienteId()
      this.getContactoCliente()
    },
    methods: {
      existeClienteId () {
        if (!this.$route.params.cliente_id) {
          this.$router.push({ name: 'clientes' })
        } else {
          this.getContactoCliente()
          this.cliente_id = this.$route.params.cliente_id
        }
      },
      newContacto () {
        this.$refs.newContactoCliente.open()
      },
      async getContactoCliente () {
        this.contactos = []
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/instaladores/contactos')

        const data = await response.json()
        this.contactos = data.data
      },
      onCreate () {
        this.getContactoCliente()
      },
      editarContacto (item) {
        this.$refs.newContactoCliente.open(item)
      },
      dialogDelete (item) {
        this.$refs.dialogContacto.open('Eliminar Contacto', '¿Esta seguro de eliminar el contacto seleccionado?', item)
      },
      onDialog (data) {
        this.eliminarContacto(data)
      },
      async eliminarContacto (contacto) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/instaladores/contacto/' + contacto.id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        const data = await response.json()
        if (data.success) {}

        this.$refs.dialogContacto.close()
        this.getContactoCliente()
      },
      async exportarExcel () {
        try {
          this.isLoadingDownload = true
          const data = [
            {
              sheet: 'Campañas',
              columns: [
                { label: 'NOMBRE', value: 'nombre' },
                { label: 'APELLIDO PATERNO', value: 'primer_apellido' },
                { label: 'APELLIDO MATERNO', value: 'segundo_apellido' },
                { label: 'DEPARTAMENTO', value: 'departamento' },
                { label: 'PROVINCIA', value: 'provincia' },
                { label: 'DISTRITO', value: 'distrito' },
                { label: 'DIRECCION', value: 'direccion' },
                { label: 'DNI', value: 'dni' },
                { label: 'ESPECIALIZACION', value: 'especializacion' },
                // { label: 'FOTO', value: 'foto' },
                { label: 'CELULAR', value: 'celular' },
                { label: 'CORREO', value: 'correo' }
              ],
              content: [
                ...this.contactos
              ]
            }]
  
          const settings = {
            sheetName: 'Data',
            fileName: 'Instaladores'
          }
  
          await xlsx(data, settings)
          this.isLoadingDownload = false
        } catch (error) {
          this.isLoadingDownload = false
        }
      },
    },
  }
</script>

<style>

</style>
